<div
    *ngIf="answer.type === 'single_select' || answer.type === 'multi_select'"
    class="row container"
>
    <p
        *ngIf="answer.label"
        [innerHTML]="answer.label.replace('{brand}', brandName)"
    ></p>
    <div
        *ngFor="let option of answer?.options"
        [class]="data[option.key] === true && option.answer ? 'full-width' : ''"
    >
        <label
            *ngIf="editMode || (!editMode && data[option.key])"
            nz-checkbox
            class="select"
            [ngModel]="data[option.key] | bool"
            [name]="field + '_' + option.key"
            (ngModelChange)="change($event, data, option.key, answer)"
            [nzDisabled]="!editMode"
            >{{ option.value }}
        </label>

        <my-health-admin-answer
            *ngIf="data[option.key] === true && option.answer"
            [field]="field"
            [data]="data"
            [answer]="option.answer"
            [editMode]="editMode"
            [brand]="brand"
        ></my-health-admin-answer>
    </div>
</div>

<div *ngIf="answer.type === 'weightHeight'">
    <common-weight-height
        [data]="data"
        [showLabel]="answer.showLabel"
        [editMode]="editMode"
    ></common-weight-height>
</div>

<div *ngIf="answer.type === 'bmi'">
    <common-bmi
        [data]="data"
        [answer]="answer"
        [editMode]="editMode"
    ></common-bmi>
</div>

<div *ngIf="answer.type === 'list'">
    <div *ngFor="let item of answer.items" class="list-answers">
        <my-health-admin-answer
            [field]="field"
            [data]="data"
            [answer]="item"
            [editMode]="editMode"
            [brand]="brand"
        ></my-health-admin-answer>
    </div>
</div>

<div *ngIf="answer.type === 'radio'" class="sub-item">
    <p>{{ answer.label }}</p>
    <nz-radio-group
        [name]="field + '_' + answerName"
        [(ngModel)]="data[answerName]"
    >
        <label
            nz-radio
            *ngFor="let option of answer.options"
            [nzValue]="option.key"
            [nzDisabled]="!editMode"
            >{{ option.value }}</label
        >
    </nz-radio-group>

    <div *ngFor="let optionAnswer of optionAnswers | keyvalue">
        <my-health-admin-answer
            *ngIf="optionAnswer.value && optionAnswer.key === data[answerName]"
            [field]="field"
            [data]="data"
            [answer]="optionAnswer.value"
            [editMode]="editMode"
            [brand]="brand"
        ></my-health-admin-answer>
    </div>
</div>

<div *ngIf="answer.type === 'text'" class="sub-item">
    <h6 *ngIf="answer.label">{{ answer.label }}</h6>

    <nz-input-group
        [nzSuffix]="textAreaClearTpl"
        class="ant-input-affix-wrapper-textarea-with-clear-btn"
    >
        <textarea
            nz-input
            [name]="field + '_' + answerName"
            [(ngModel)]="data[answerName]"
            [rows]="answer.rows || 3"
            [placeholder]="answer.placeholder ? answer.placeholder : ''"
            [disabled]="!editMode"
            required
        ></textarea>
    </nz-input-group>
    <ng-template #textAreaClearTpl
        ><i
            nz-icon
            class="ant-input-textarea-clear-icon"
            nzTheme="fill"
            nzType="close-circle"
            *ngIf="editMode && data[answerName]"
            (click)="data[answerName] = null"
        ></i
    ></ng-template>
</div>

<div *ngIf="answer.type === 'number'" class="sub-item">
    <p *ngIf="answer.label">{{ answer.label }}</p>

    <nz-input-number
        style="width: 100%"
        [name]="field + '_' + answerName"
        [(ngModel)]="data[answerName]"
        [nzMin]="1"
        [nzMax]="100000"
        [nzStep]="1"
        [nzDisabled]="!editMode"
        required
    ></nz-input-number>
</div>

<div *ngIf="answer.type === 'date'" class="sub-item">
    <h4 *ngIf="answer.label">{{ answer.label }}</h4>

    <nz-date-picker
        [name]="field + '_' + answerName"
        [(ngModel)]="data[answerName]"
        [nzDisabled]="!editMode"
        required
    ></nz-date-picker>
</div>

<div *ngIf="answer.type === 'esign'" class="sub-item">
    <h4 *ngIf="answer.label">{{ answer.label }}</h4>
    <p>Signature:</p>
    <img
        *ngIf="files?.[data.answer?.name]"
        [src]="files?.[data.answer?.name]?.buffer"
        alt="signature"
        height="150"
    />
</div>

<div *ngIf="answer.type === 'dropdown'" class="sub-item">
    <h4 *ngIf="answer.label">{{ answer.label }}</h4>

    <nz-select
        [name]="field + '_' + answerName"
        [(ngModel)]="data[answerName]"
        nzAllowClear
        [nzPlaceHolder]="answer.placeholder || ''"
        [nzDisabled]="!editMode"
        style="width: 100%"
        required
    >
        <nz-option
            *ngFor="let option of answer.options"
            [nzValue]="option.key"
            [nzLabel]="option.value"
        ></nz-option>
    </nz-select>
</div>

<div *ngIf="answer.type === 'checkbox'" class="sub-item">
    <label
        nz-checkbox
        [(ngModel)]="data[answerName]"
        [name]="field + '_' + answerName"
        [nzDisabled]="!editMode"
        >{{ answer.label }}
    </label>
</div>

<div *ngIf="answer.type === 'consent-check'" class="sub-item">
    <h4 *ngIf="answer.label">{{ answer.label }}</h4>

    <label
        nz-checkbox
        [name]="field + '_' + answerName"
        [(ngModel)]="data['accept']"
        [nzDisabled]="!editMode"
        >{{ answer.agreeLabel || 'I Agree' }}</label
    >

    <input
        type="text"
        class="hidden"
        [name]="field + '_validAnswer'"
        [ngModel]="isAccept"
        required
    />
</div>

<div *ngIf="answer.type === 'measure'" class="measure sub-item">
    <my-health-admin-answer
        *ngIf="
            !(
                answer.value.name === 'height' &&
                data['heightUnit'] === 'feetIn'
            );
            else feetInTmp
        "
        class="value"
        [field]="field"
        [data]="data"
        [answer]="answer.value"
        [editMode]="editMode"
    ></my-health-admin-answer>
    <span class="divider" [innerHTML]="answer.division"></span>
    <my-health-admin-answer
        class="unit"
        [field]="field"
        [data]="data"
        [answer]="answer.unit"
        [editMode]="editMode"
    ></my-health-admin-answer>

    <ng-template #feetInTmp>
        <div style="width: 45%">
            <my-health-admin-answer
                [data]="data"
                [answer]="{ type: 'feetIn', size: 'medium' }"
            ></my-health-admin-answer>
        </div>
    </ng-template>
</div>

<div *ngIf="answer.type === 'feetIn'" class="feetIn">
    <nz-input-number
        style="flex: 0.5"
        [name]="field + '_feet'"
        [(ngModel)]="data['feet']"
        [nzSize]="answer.size"
        nzPlaceHolder="feet"
        [nzMax]="answer.max || 'Infinity'"
        [nzMin]="0"
        [disabled]="!editMode"
        required
    ></nz-input-number>

    <nz-input-number
        style="flex: 0.5"
        [name]="field + '_inches'"
        [(ngModel)]="data['inches']"
        [nzSize]="answer.size"
        nzPlaceHolder="inches"
        [nzMax]="11"
        [nzMin]="0"
        [disabled]="!editMode"
        required
    ></nz-input-number>
</div>

<div *ngIf="answer.type === 'measure-list'" class="measure sub-item">
    <my-health-admin-answer
        class="value"
        [field]="field"
        [data]="data"
        [answer]="answer.value1"
        [editMode]="editMode"
    ></my-health-admin-answer>
    <span class="unit-label" [innerHTML]="answer.unit1"></span>
    <my-health-admin-answer
        class="value"
        [field]="field"
        [data]="data"
        [answer]="answer.value2"
        [editMode]="editMode"
    ></my-health-admin-answer>
    <span class="unit-label" [innerHTML]="answer.unit2"></span>
</div>

<div *ngIf="answer.type === 'calculated'" class="calculated">
    <p class="span-box">
        {{ answer.label }}: {{ answer.answer.formula(data) }}
    </p>
</div>

<div *ngIf="answer.type === 'text_list'" class="row container">
    <p>
        {{ answer.label }}
    </p>

    <div
        class="row answers center"
        *ngFor="let item of data['list']; let i = index"
    >
        <div class="full-width line">
            <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
                <input
                    type="text"
                    nz-input
                    [name]="field + '_list_' + i"
                    [(ngModel)]="item.name"
                    [placeholder]="answer.inputPlaceholder"
                    [disabled]="!editMode"
                    required
                />
            </nz-input-group>
            <ng-template #suffixIconButton>
                <button
                    nz-button
                    nzType="primary"
                    nzSearch
                    (click)="removeItem(i, data)"
                    [disabled]="!editMode"
                >
                    <i nz-icon nzType="delete"></i>
                </button>
            </ng-template>
        </div>
    </div>

    <div class="row center">
        <button
            nz-button
            nzType="default"
            (click)="addItem(data)"
            [disabled]="!editMode"
        >
            <i nz-icon nzType="plus-circle" nzTheme="fill"></i>Add More
        </button>
    </div>
</div>

<div *ngIf="answer.type === 'transfer-rx'" class="row full-width">
    <div class="card padded col half">
        <img
            class="rx-img"
            alt="transfer rx file"
            [src]="transferRxFile.buffer"
        /><img />
    </div>

    <textarea
        class="card padded col half rx-text"
        [class.checked]="data[answer.option2.name]"
        nz-input
        [name]="field + '_' + answer.option2.name"
        [(ngModel)]="data[answer.option2.name]"
        [placeholder]="
            answer.option2.placeholder ? answer.option2.placeholder : ''
        "
        [disabled]="!editMode"
        required
    ></textarea>
</div>

<div *ngIf="answer.type === 'branch'">
    <div *ngFor="let item of answer.items">
        <my-health-admin-answer
            *ngIf="checkCondition(item.condition)"
            [data]="data"
            [answer]="item.answer"
        ></my-health-admin-answer>
    </div>
</div>

<div *ngIf="answer.type === 'healthCard'">
    <nz-descriptions nzTitle [nzColumn]="1">
        <nz-descriptions-item nzTitle="HC number" [nzSpan]="1"
            ><span>{{ data.hcNum }}</span></nz-descriptions-item
        >
        <nz-descriptions-item
            *ngIf="data.hcType == 'Ontario'"
            nzTitle="HC symbol"
            [nzSpan]="1"
            ><span>{{ data.hcVer }}</span></nz-descriptions-item
        >
        <nz-descriptions-item
            *ngIf="data.hcType == 'Non-Ontario'"
            nzTitle="Province"
            [nzSpan]="1"
            ><span>{{ data.hcProv }}</span></nz-descriptions-item
        >
        <nz-descriptions-item nzTitle="Issue Date" [nzSpan]="1"
            ><span>{{ data.hcEff }}</span></nz-descriptions-item
        >
        <nz-descriptions-item nzTitle="Expiry Date" [nzSpan]="1"
            ><span>{{ data.hcExp }}</span></nz-descriptions-item
        >
    </nz-descriptions>
</div>

<div *ngIf="question?.type === 'file_upload'">
    <div class="gallery">
        <ng-container *ngFor="let image of images">
            <div style="display: flex; gap: 1rem">
                <div class="img-container">
                    <img
                        [ngStyle]="{
                            visibility: image.loading ? 'hidden' : ''
                        }"
                        [src]="image.path | file | async"
                        [alt]="image.name"
                        (load)="image.loading = false"
                        style="height: 200px; width: auto"
                    />
                    <div *ngIf="image.loading" class="loading-spinner">
                        Loading...
                    </div>
                </div>

                <div style="display: flex; flex-direction: column; gap: 0.5rem">
                    <button
                        (click)="newFile.click()"
                        nz-button
                        nzType="primary"
                    >
                        Upload
                    </button>
                    <small>
                        Current image will stay in the patient files, Uploaded
                        images are automatically saved to the customer's files,
                        even without clicking Save
                    </small>
                    <input
                        class="hidden"
                        type="file"
                        accept="image/jpeg, image/jpg, image/png, application/pdf"
                        #newFile
                        (change)="processImage(image.name, newFile)"
                    />
                </div>
            </div>
        </ng-container>
    </div>
</div>
